import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';
import MarcaACH from './MarcaACH';

function Navbar() {
  const { user, logout, isInstructor } = useAuth();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="navbar-content">
        <Link to="/" className="navbar-brand">
          <MarcaACH mida={20} />
          {t('nav.brandName')}
        </Link>

        {user ? (
          <ul className="navbar-nav">
            <li><Link to="/">{t('nav.dashboard')}</Link></li>
            <li><Link to="/theory">{t('nav.theory')}</Link></li>
            <li><Link to="/missions">{t('nav.missions')}</Link></li>
            {isInstructor && (
              <li><Link to="/users">{t('nav.users')}</Link></li>
            )}
            {isInstructor && (
              <li><Link to="/equips">{t('nav.equips')}</Link></li>
            )}
            <li>
              {/* Els estils van a `.navbar-perfil` (App.css) i no aquí dins.
                  Un estil en línia guanya qualsevol selector, i el color que hi
                  havia escrit —`--color-text-secondary`, pensat per a una barra
                  blanca— quedava per sota del contrast mínim damunt de la barra
                  fosca. Els colors de la barra els ha de decidir el full. */}
              <Link to="/profile" className="navbar-perfil">
                {/* Un equip s'ha de reconèixer per «Equip 07», no per «equip-07»:
                    el username és la identitat tècnica i el subjecte del token. */}
                {user.display_name || user.username}
                <span className={`badge badge-${isInstructor ? 'primary' : 'success'}`}>
                  {user.role}
                </span>
              </Link>
            </li>
            <li>
              <LanguageSwitcher />
            </li>
            <li>
              {/* `btn-navbar` és el botó dins de la barra: mida i tractament
                  sobre fons fosc, tots dos al full. */}
              <button onClick={handleLogout} className="btn btn-secondary btn-navbar">
                {t('auth.logout')}
              </button>
            </li>
          </ul>
        ) : (
          <ul className="navbar-nav">
            {/* Sense sessió no s'ofereix la teoria: és material del curs. */}
            <li><Link to="/login">{t('auth.login')}</Link></li>
            <li><Link to="/register">{t('auth.register')}</Link></li>
            <li>
              <LanguageSwitcher />
            </li>
          </ul>
        )}
      </div>
    </nav>
  );
}

export default Navbar;